import { Component, Input } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-progress-circle',
  templateUrl: './progress-circle.component.html',
  styleUrls: ['./progress-circle.component.scss']
})
export class ProgressCircleComponent {
  @Input() percent: any;
}
